import type { PublicApiEndpoint } from "@constructorfleet/offerings-sdk";

export const bhgCallPublicApiEndpoints: { basePath: string; endpoints: PublicApiEndpoint[] } = {
  basePath: "/api/v1/bhg-call",
  endpoints: [
    {
      method: "GET",
      path: "/calls",
      summary: "List all calls for your account, newest first.",
      responseExample: JSON.stringify(
        {
          ok: true,
          calls: [
            {
              id: 1042,
              userId: 42,
              startedAt: "2026-04-24 07:00 UTC",
              status: "completed",
              resultLabel: "Drug Screen",
              resultDate: "2026-04-24",
              callSid: "CA1234567890abcdef",
              transcript: "You are scheduled for a drug screen today…",
              recordingAvailable: true,
              recordingS3Key: null,
              resultNotificationSent: true,
              errorReason: null,
              voiceProvider: "twilio",
            },
          ],
        },
        null,
        2
      ),
    },
    {
      method: "GET",
      path: "/calls/:callSid",
      summary: "Get a single call by its SID.",
      params: [
        {
          name: "callSid",
          in: "path",
          type: "string",
          required: true,
          description: "The call SID (e.g. CA1234567890abcdef).",
        },
      ],
      responseExample: JSON.stringify(
        {
          ok: true,
          call: {
            id: 1042,
            userId: 42,
            startedAt: "2026-04-24 07:00 UTC",
            status: "completed",
            resultLabel: "Drug Screen",
            resultDate: "2026-04-24",
            callSid: "CA1234567890abcdef",
            transcript: "You are scheduled for a drug screen today…",
            recordingAvailable: true,
            recordingS3Key: null,
            resultNotificationSent: true,
            errorReason: null,
            voiceProvider: "twilio",
          },
        },
        null,
        2
      ),
      errorCodes: [
        { code: 400, description: "Invalid call SID." },
        { code: 404, description: "Call not found." },
      ],
    },
    {
      method: "GET",
      path: "/calls/:callSid/events",
      summary: "List webhook events for a specific call (up to 200).",
      params: [
        {
          name: "callSid",
          in: "path",
          type: "string",
          required: true,
          description: "The call SID.",
        },
      ],
      responseExample: JSON.stringify(
        {
          ok: true,
          callSid: "CA1234567890abcdef",
          events: [
            {
              id: 501,
              callSid: "CA1234567890abcdef",
              createdAt: "2026-04-24T07:00:12.345Z",
              callStatus: "in-progress",
              callDurationSeconds: null,
              transcript: null,
              payloadKeys: ["AccountSid", "CallSid", "CallStatus"],
            },
          ],
        },
        null,
        2
      ),
      errorCodes: [{ code: 400, description: "Invalid call SID." }],
    },
    {
      method: "GET",
      path: "/webhook",
      summary: "Get your current webhook configuration.",
      responseExample: JSON.stringify(
        {
          ok: true,
          webhook: {
            endpointUrl: "https://your-server.com/webhook",
            enabled: true,
            createdAt: "2026-04-20T15:00:00.000Z",
          },
        },
        null,
        2
      ),
    },
    {
      method: "PUT",
      path: "/webhook",
      summary: "Create or update your webhook endpoint.",
      params: [
        {
          name: "endpointUrl",
          in: "body",
          type: "string",
          required: true,
          description: "The HTTPS URL to receive webhook events.",
        },
        {
          name: "enabled",
          in: "body",
          type: "boolean",
          required: false,
          description: "Whether the webhook is active. Defaults to true.",
        },
      ],
      responseExample: JSON.stringify(
        {
          ok: true,
          webhook: {
            endpointUrl: "https://your-server.com/webhook",
            secret: "whsec_abc123…",
            enabled: true,
          },
        },
        null,
        2
      ),
      errorCodes: [
        { code: 400, description: "endpointUrl is required." },
        { code: 400, description: "endpointUrl must be a valid URL." },
      ],
    },
    {
      method: "DELETE",
      path: "/webhook",
      summary: "Delete your webhook configuration.",
      responseExample: JSON.stringify({ ok: true }, null, 2),
    },
  ],
};
